import * as React from 'react';

import { useSlug } from '../hooks/useSlug';
import { GlobalProps } from '../types';
import { classes } from '../utils';

import styles from './styles.module.css';

export type ErrorTextProps = GlobalProps & {
  errorMsg?: string;
  variant?: 'default' | 'dark';
};

export const ErrorText = React.forwardRef<HTMLDivElement, ErrorTextProps>(
  function ErrorTextComponent(props, ref): JSX.Element | null {
    const { errorMsg, name = 'error-text', variant = 'default' } = props;
    const slugName = useSlug(name);

    const cx = classes(
      [
        styles.wrapper,
        'error-text-box',
        {
          [styles.wrapper]: variant === 'default',
          [styles.wrapperDark]: variant === 'dark',
          [styles.hide]: !errorMsg,
          [styles.visible]: errorMsg,
        },
      ],
      props
    );

    return (
      <div
        className={cx}
        role="alert"
        aria-atomic
        ref={ref}
        data-component={slugName}
      >
        {errorMsg}
      </div>
    );
  }
);
